import { Card } from '@/models/Card';
import { PlayerRole } from './PlayerRole';

export class Player {
  private _connectionId: string;
  private _name: string;
  private _role: PlayerRole;
  private _cardSelected: boolean | null = null;
  private _selectedCard: Card | null = null;

  constructor(connectionId: string, name: string, role = PlayerRole.Player) {
    this._connectionId = connectionId;
    this._name = name;
    this._role = role;
  }

  public get connectionId(): string {
    return this._connectionId;
  }
  public get name(): string {
    return this._name;
  }
  public get role(): PlayerRole {
    return this._role;
  }
  public updateDetails(name: string, role: PlayerRole) {
    this._name = name;
    this._role = role;
  }

  public get cardSelected(): boolean | null {
    return this._cardSelected;
  }
  public get selectedCard(): Card | null {
    return this._selectedCard;
  }

  public setCardSelected(value: boolean) {
    this._cardSelected = value;
  }
  public setCard(card: Card) {
    this._selectedCard = card;
  }
  public clear() {
    this._selectedCard = null;
    this._cardSelected = false;
  }
}
